import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Footer from "../Footer";
import Header from "../Header";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import "../..//assets/css/login.css";
import axios from "axios";
import auth from "../../utils/auth";
import { IonPage } from "@ionic/react";

const Login = (props) => {
	const [isOpaque, setIsOpaque] = useState(true);

	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");
	const [error, setError] = useState("");

	const navigate = useNavigate();
	const location = useLocation();

	useEffect(() => {
		window.addEventListener("scroll", (e) => {
			if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
				setIsOpaque(false);
			} else {
				setIsOpaque(true);
			}
		});

		return () => {
			window.removeEventListener("scroll", (e) => {
				if (e.currentTarget.scrollY || e.currentTarget.scrollY > 90) {
					setIsOpaque(false);
				} else {
					setIsOpaque(true);
				}
			});
		};
	}, []);

	const loginUser = async () => {
		if (!email || !password) {
			setError("Please enter your email and password");
			return;
		}
		try {
			const response = await axios.post("/auth/login", {
				email,
				password,
			});

			await auth.setToken(response.data.token, true);
			await auth.setUserInfo(response.data.user, true);

			navigate(location.state?.from || "/courses", { replace: true });
		} catch (e) {
			console.log(e.response?.data.message || e);
			setError(e.response?.data.message || "Something went wrong");
		}
	};

	return (
		<IonPage>
			<div id="header_place">
				<Header isOpaque={isOpaque} isBlue={true} />
			</div>
			<section id="hero_area4">
				<div className="center_wrapper">
					<Carousel
						showThumbs={false}
						showStatus={false}
						showArrows={false}
						swipeable={true}
						className="c1"
					>
						<div className="slide_wrapper2">
							<p>Your learning journey starts here</p>
							<img
								src={`${process.env.PUBLIC_URL}/assets/illustration.png`}
								className="illustration"
							/>
							<h3>Feedback based learning</h3>
						</div>
						<div className="slide_wrapper2">
							<p>Your learning journey starts here</p>
							<img
								src={`${process.env.PUBLIC_URL}/assets/illustration.png`}
								className="illustration"
							/>
							<h3>Feedback based learning</h3>
						</div>
						<div className="slide_wrapper2">
							<p>Your learning journey starts here</p>
							<img
								src={`${process.env.PUBLIC_URL}/assets/illustration.png`}
								className="illustration"
							/>
							<h3>Feedback based learning</h3>
						</div>
					</Carousel>
					<div className="login_content">
						<h1>Sign In</h1>
						<p className="subtext">
							New to Wyden? Create an account{" "}
							<a href="/auth/register">here</a>.
						</p>
						{error && (
							<div className="auth_error" role="alert">
								<span className="auth_error_icon">!</span>
								{error}
							</div>
						)}
						<input
							id="login_email"
							type="email"
							placeholder="Email Id"
							className={"phone-number" + (error ? " has-error" : "")}
							value={email}
							onChange={(e) => {
								setEmail(e.target.value);
								setError("");
							}}
						/>
						<input
							id="password"
							type="password"
							placeholder="Password"
							className={"phone-number" + (error ? " has-error" : "")}
							value={password}
							onKeyDown={(e) => {
								if (e.key === "Enter") loginUser();
							}}
							onChange={(e) => {
								setPassword(e.target.value);
								setError("");
							}}
						/>
						<button
							type="button"
							className="send-otp"
							id="form_login_button"
							onClick={loginUser}
						>
							Sign In
						</button>
					</div>
				</div>
			</section>
		</IonPage>
	);
};

export default Login;
